<template>
  <modal-template :name="modalName">
    <template slot="header">
      <h2 class="h1" v-t="'modal.ticket_advisory_title'"/>
    </template>
    <template slot="default">
      <div v-html="advisory"/>
    </template>
    <template slot="footer">
      <button class="btn--inverted" @click="advisoryConfirmed">{{ $t('buttons.ok') }}</button>
    </template>
  </modal-template>
</template>
<script>
import ModalTemplate from "@/components/modals/ModalTemplate.vue";

export default {
  name: "modal-advisory",
  components: {
    ModalTemplate
  },
  data() {
    return {
      modalName: "modal-advisory",
    };
  },
  props: {
    advisory: {
      type: String,
      required: false,
    },
  },
  methods: {
    advisoryConfirmed() {
      this.$emit("advisoryConfirmed");
      this.$modal.hide(this.modalName);
    },
  },
};
</script>
